import apiClient from '../client'
import type { NoticeSettingItem, NoticeSettingUpsert } from './types'

const mgmtBase = (municipalityId: number) => `/api/municipalities/${municipalityId}/notice-settings`

export const noticeSettingsApi = {
  // ── ログインユーザー自治体スコープ版（独立管理画面 /admin/notice-settings 用。ADMIN）──
  /** 自分の自治体の決定通知書設定項目を取得する。 */
  listForMyMunicipality() {
    return apiClient.get<NoticeSettingItem[]>('/api/admin/notice-settings')
  },
  /** 自分の自治体の決定通知書設定項目を1件保存する。 */
  saveForMyMunicipality(body: NoticeSettingUpsert) {
    return apiClient.put<NoticeSettingItem>('/api/admin/notice-settings', body, { _silent: true })
  },

  // ── パス固定版（SYSTEM_ADMIN が自治体を選んで維護。MUNICIPALITY_MGMT）──
  /** 指定自治体の決定通知書設定項目を取得する。 */
  listForManagement(municipalityId: number) {
    return apiClient.get<NoticeSettingItem[]>(mgmtBase(municipalityId))
  },
  /** 指定自治体の決定通知書設定項目を1件保存する。 */
  saveForManagement(municipalityId: number, body: NoticeSettingUpsert) {
    return apiClient.put<NoticeSettingItem>(mgmtBase(municipalityId), body, { _silent: true })
  },
}
